<template>
  <div>
    <sub-content-container :title="$t('myInterests.sports.title')">
      <interest :interests="completeInterests" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Interest = () =>
  import(/* webpackChunkName: "MyInterestsPage" */ "@/components/MyInterests/Interest.vue");

export default {
  name: "Sports",
  components: {
    SubContentContainer,
    Interest
  },
  data() {
    return {
      interests: [
        {
          icon: ["fas", "dumbbell"],
          backgroundColor: "black"
        },
        {
          icon: ["fas", "utensils"]
        },
        {
          icon: ["fas", "hands"],
          backgroundColor: "black"
        },
        {
          icon: ["fas", "running"]
        },
        {
          icon: ["fas", "running"],
          backgroundColor: "black"
        }
      ]
    };
  },
  computed: {
    completeInterests() {
      return this.interests.map((data, i) => ({
        ...data,
        ...this.$t("myInterests.sports.interests")[i]
      }));
    }
  }
};
</script>
